import { z } from "zod";

import { EnumValues } from "../index.js";
import { getNormalEnum } from "../pseudoEnums.js";

export const DataBrowserIdTypeLiteral = z.enum([
  "data-connection",
  "database",
  "schema",
  "table",
]);

export type DataBrowserIdType = z.infer<typeof DataBrowserIdTypeLiteral>;
export const DataBrowserIdType = getNormalEnum(DataBrowserIdTypeLiteral);

export const DataBrowserSemanticIdType = {
  PROJECT: "semantic-project",
  DATASET: "semantic-model",
  VIEW: "semantic-view",
  /** @deprecated use `PROJECT` instead */
  PROJECT_DEPRECATED: "model",
} as const;
export type DataBrowserSemanticIdType = EnumValues<
  typeof DataBrowserSemanticIdType
>;

/** AKA "detail view type" route param: .../data/recommended/:detailViewType */
export const DataBrowserRecommendedIdTypeLiteral = z.enum([
  "recently-used",
  "favorites",
  "endorsed",
]);
export type DataBrowserRecommendedIdType = z.infer<
  typeof DataBrowserRecommendedIdTypeLiteral
>;
export const DataBrowserRecommendedIdType = getNormalEnum(
  DataBrowserRecommendedIdTypeLiteral,
);
